// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"ae049e80","567":"ae049e80"}[chunkId] + ".chunk.css";
};